/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterContratos() {
        return axiosJwt
            .get(`${api}/fornecedor/contratos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRequisicoes(codContrato) {
        let url = `${api}/fornecedor/contratos/${codContrato}/requisicoes`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRequisicao(codContrato, idRequisicao) {
        let url = `${api}/fornecedor/contratos/${codContrato}/requisicoes/${idRequisicao}`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexos(fornecedorId, codContrato, idComprometimento) {
        let url = `${api}/fornecedor/contratos/${codContrato}/comprometimentos/${idComprometimento}/anexos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexosTipos(codContrato) {
        let url = `${api}/fornecedor/contratos/${codContrato}/comprometimentos/anexos/tipos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirComprometimentoAnexo(codContrato, anexo) {
        const formData = new FormData()
        formData.append('idComprometimento', anexo.idComprometimento)
        formData.append('tipoId', anexo.tipoId)
        formData.append('descritivo', anexo.descritivo)
        formData.append('arquivo', anexo.arquivo)

        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/${codContrato}/comprometimentos/${anexo.idComprometimento}/anexos/`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexo(
        codContrato,
        idComprometimento,
        comprometimentoAnexoId
    ) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/${codContrato}/comprometimentos/${idComprometimento}/anexos/${comprometimentoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirComprometimentoAnexo(
        codContrato,
        idComprometimento,
        comprometimentoAnexoId
    ) {
        let url = `${api}/fornecedor/contratos/${codContrato}/comprometimentos/${idComprometimento}/anexos/${comprometimentoAnexoId}`
        return axiosJwt
            .delete(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    enviarComprometimentoParaAnalise(codContrato, idComprometimento) {
        let url = `${api}/fornecedor/contratos/${codContrato}/comprometimentos/${idComprometimento}/enviaranalise`
        return axiosJwt
            .patch(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    cancelarEnvioComprometimentoParaAnalise(codContrato, idComprometimento) {
        let url = `${api}/fornecedor/contratos/${codContrato}/comprometimentos/${idComprometimento}/cancelarenvioanalise`
        return axiosJwt
            .patch(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAprovadores(codContrato, idComprometimento) {
        let url = `${api}/fornecedor/contratos/${codContrato}/comprometimentos/${idComprometimento}/aprovadores`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentos(codContrato) {
        let url = `${api}/fornecedor/contratos/${codContrato}/comprometimentos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(codContrato, idComprometimento) {
        let url = `${api}/fornecedor/contratos/${codContrato}/comprometimentos/${idComprometimento}/timeline`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }

}
